var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#895C50"
    },
    points: "328.1,456.2 168.1,456.2 167.036,280.2 329.804,280.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE23A"
    },
    d: "M467.204,326.392l-121.552-41.976l2.568-6.864l-15.896-6.664 c-6.344,28.736-41.584,50.76-84.216,50.76c-42.648,0-77.872-22.008-84.208-50.744l-15.92,6.672l2.576,6.888l-121.56,41.928 L5.932,496.2h30.736h156.736h47.528h14.328h49.736h154.528h30.736L467.204,326.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6C425"
    },
    d: "M8.1,496.2h28.568h156.736h47.528h14.328h49.736h154.528h30.736l-23.064-169.808l-121.552-41.976 l2.568-6.864l-15.896-6.664c-6.344,28.736-41.584,50.76-84.216,50.76c-42.648,0-77.872-22.008-84.208-50.744l-15.92,6.672 l3.664,6.792"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCA70D"
    },
    d: "M240.1,496.2h15.168h49.736h154.528h30.736l-23.064-169.808l-121.552-41.976l2.568-6.864 l-15.896-6.664c-6.344,28.736-42,50.656-84.64,50.656"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#895C50"
    },
    points: "309.34,304.2 188.668,304.2 196.724,200.2 301.3,200.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#895C50"
    },
    points: "311.268,302.104 248.108,467.608 184.932,302.104 248.108,302.776  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#774940"
    },
    points: "309.356,301.312 261.548,398.744 188.684,200.2 301.308,200.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A87160"
    },
    d: "M327.94,132.968c0-70.032-31.84-106.368-79.84-106.648v-0.032v0.016v-0.016v0.032 c-48,0.28-79.84,36.616-79.84,106.648s31.84,133.36,79.84,134.856v0.144v-0.064v0.064v-0.144 C296.1,266.328,327.94,203,327.94,132.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#895C50"
    },
    d: "M248.1,264.2v3.768v-0.064v0.064v-0.144c48-1.504,79.84-64.824,79.84-134.856S296.1,26.6,248.1,26.32 v-0.032v0.016v-0.016V24.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M203.908,215.792c-0.2-0.224-0.312-0.376-0.312-0.376S203.668,215.632,203.908,215.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M294.124,215.792c0.2-0.224,0.312-0.376,0.312-0.376S294.356,215.632,294.124,215.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 164.436,
    cy: 316.104,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 175.436,
    cy: 346.44,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 186.436,
    cy: 376.76,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 197.436,
    cy: 407.088,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 208.42,
    cy: 437.416,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 219.436,
    cy: 467.72,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 331.78,
    cy: 316.104,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 320.74,
    cy: 346.44,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 309.764,
    cy: 376.76,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 298.74,
    cy: 407.088,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 287.764,
    cy: 437.416,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFE23A"
    },
    cx: 276.764,
    cy: 467.72,
    r: 5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 185.059,
    y: 163.356,
    transform: "matrix(-0.9128 -0.4085 0.4085 -0.9128 314.4345 401.19)",
    style: {
      fill: "#34D159"
    },
    width: 29.993,
    height: 7.328
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.351,
    y: 177.012,
    transform: "matrix(-0.9128 -0.4085 0.4085 -0.9128 305.5885 426.6123)",
    style: {
      fill: "#EFE23A"
    },
    width: 29.993,
    height: 7.328
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.666,
    y: 190.666,
    transform: "matrix(-0.9129 -0.4083 0.4083 -0.9129 296.8598 452.0293)",
    style: {
      fill: "#FF6485"
    },
    width: 30.009,
    height: 7.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.217,
    y: 163.344,
    transform: "matrix(0.9128 -0.4085 0.4085 0.9128 -42.3803 135.5675)",
    style: {
      fill: "#34D159"
    },
    width: 29.993,
    height: 7.328
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.898,
    y: 176.991,
    transform: "matrix(0.9128 -0.4085 0.4085 0.9128 -47.808 137.4448)",
    style: {
      fill: "#EFE23A"
    },
    width: 29.993,
    height: 7.328
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.496,
    y: 190.673,
    transform: "matrix(0.9128 -0.4084 0.4084 0.9128 -53.2539 139.2605)",
    style: {
      fill: "#FF6485"
    },
    width: 30,
    height: 7.336
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.438,
    y: 384.674,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 361.5774 642.2503)",
    style: {
      fill: "#34D159"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.118,
    y: 384.683,
    transform: "matrix(-0.7073 0.7069 -0.7069 -0.7073 424.1449 616.4222)",
    style: {
      fill: "#34D159"
    },
    width: 22.68,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.769,
    y: 384.712,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 486.7866 590.4625)",
    style: {
      fill: "#34D159"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.43,
    y: 384.675,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 549.3448 564.4758)",
    style: {
      fill: "#34D159"
    },
    width: 22.672,
    height: 22.672
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.411,
    y: 441.647,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 401.8158 739.5278)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.063,
    y: 441.667,
    transform: "matrix(-0.7073 0.7069 -0.7069 -0.7073 464.3333 713.7499)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.68,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.709,
    y: 441.629,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 526.9309 687.667)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.402,
    y: 441.647,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 589.5833 661.7533)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.672,
    height: 22.672
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.753,
    y: 412.687,
    transform: "matrix(-0.7073 0.7069 -0.7069 -0.7073 410.8778 677.9221)",
    style: {
      fill: "#FF6485"
    },
    width: 22.68,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.445,
    y: 412.674,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 473.5703 651.8601)",
    style: {
      fill: "#FF6485"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.093,
    y: 412.687,
    transform: "matrix(-0.7073 0.7069 -0.7069 -0.7073 536.0884 626.0708)",
    style: {
      fill: "#FF6485"
    },
    width: 22.68,
    height: 22.664
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.767,
    y: 412.672,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 598.7376 600.0096)",
    style: {
      fill: "#FF6485"
    },
    width: 22.672,
    height: 22.672
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 437.098,
    y: 441.644,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -188.962 449.7652)",
    style: {
      fill: "#34D159"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.394,
    y: 441.652,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -199.7176 423.814)",
    style: {
      fill: "#34D159"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.742,
    y: 441.663,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -210.4611 397.9007)",
    style: {
      fill: "#34D159"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.039,
    y: 441.647,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -221.1997 371.9426)",
    style: {
      fill: "#34D159"
    },
    width: 22.672,
    height: 22.672
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 437.111,
    y: 384.673,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -148.6736 433.088)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.407,
    y: 384.705,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -159.4462 407.1438)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.755,
    y: 384.716,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -170.1896 381.2305)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.132,
    y: 384.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -180.9048 355.3289)",
    style: {
      fill: "#36CEC6"
    },
    width: 22.672,
    height: 22.672
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 419.732,
    y: 413.728,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -174.3089 429.3092)",
    style: {
      fill: "#FF6485"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.108,
    y: 413.672,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -184.9957 403.3959)",
    style: {
      fill: "#FF6485"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.405,
    y: 413.695,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -195.7627 377.4494)",
    style: {
      fill: "#FF6485"
    },
    width: 22.672,
    height: 22.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.758,
    y: 413.701,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -206.5005 351.5385)",
    style: {
      fill: "#FF6485"
    },
    width: 22.672,
    height: 22.672
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36CEC6"
    },
    d: "M274.1,43c0,23.752-11.64,27-26,27c-14.368,0-26-3.248-26-27s11.632-43,26-43 C262.46,0,274.1,19.248,274.1,43z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#17AFA4"
    },
    d: "M248.1,0c14.36,0,26,19.248,26,43s-11.64,27-26,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#17AFA4"
    },
    points: "248.108,467.608 292.148,352.2 204.052,352.2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#169185"
    },
    points: "248.108,467.608 292.148,352.2 231.876,352.2 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.b837ef155107e835178115ca3ec35b1d.svg";
export { ForwardRef as ReactComponent };